export type PropertyType = 'condo' | 'house';

export const FLOOR_PLANS = [
  '1R', '1K', '1DK', '1LDK',
  '2K', '2DK', '2LDK',
  '3K', '3DK', '3LDK',
  '4K', '4DK', '4LDK',
  '5LDK+',
] as const;

export type FloorPlan = (typeof FLOOR_PLANS)[number];

export const ROAD_DIRECTIONS = [
  '北', '北東', '東', '南東', '南', '南西', '西', '北西',
] as const;

export type RoadDirection = (typeof ROAD_DIRECTIONS)[number];

export interface PredictRequest {
  lat: number;
  lng: number;
  propertyType: PropertyType;
  floorPlan: FloorPlan;
  buildingYear: number;
  // condo: 専有面積 / house: 土地面積
  area?: number;
  // 延床面積; only sent for house, ignored by API for condo
  floorArea?: number;
  // House-only optional inputs. Omitted (not just blank) when the user
  // doesn't fill them in; the model is trained to handle the missing
  // case without significant degradation.
  roadWidthM?: number;
  roadDirection?: RoadDirection;
}

export interface Comparable {
  tradePrice: number;
  area: number;
  floorPlan: string;
  buildingYear: number;
  period: string;
  districtName: string;
}

export interface NearestStation {
  name: string;
  distanceM: number;
}

export interface TrendsResponse {
  periods: string[];
  medianPricePerSqm: number[];
  transactionCount: number[];
  totalCount: number;
}

export interface PredictResponse {
  predictedPrice: number;
  priceRange: { low: number; high: number };
  currency: string;
  location: {
    municipalityCode: string;
    municipalityName: string;
    districtName: string | null;
    nearestStation: NearestStation | null;
    nearbyStations: NearestStation[];
    stationsWithin1kmCount: number | null;
  };
  comparables: Comparable[];
  modelVersion: string;
  warnings: string[];
}
